// extracted by mini-css-extract-plugin
export var active = "_90-7";
export var blink = "_90-8";
export var dropDownSelector = "_90-4";
export var dropDownWrapper = "_90-3";
export var fakeCursor = "_90-6";
export var fontSizeButton = "_90-9";
export var formQuillEditor = "_90-0";
export var pressed = "_90-a";
export var qlBlank = "_90-1";
export var textFormattingToolbar = "_90-2";
export var textToolbarOption = "_90-5";